export const customerHomeQuery = groq`*[_type == 'customerHome' && currentPathname == $currentPathname][0]{
    "leftSideNav":{
      welcomeGuest,
      signInMessage,
      content,
      socialMediaIcons
    },
    "linksGroup":{
      linksGroup
    },
    ...
  }`;
